import { useEffect, useState } from 'react'

export const useInitUtmIsMkSmsGames = () => {
  const [isMkSmsGames, setIsMkSmsGames] = useState(false)

  useEffect(() => {
    if (window.location.search.includes('utm_source=mksmsgames')) {
      setIsMkSmsGames(true)
      sessionStorage.setItem('isMkSmsGames', 'true')
    } else {
      const IsMkSmsGamesFromStorage = sessionStorage.getItem('isMkSmsGames')

      if (IsMkSmsGamesFromStorage) {
        setIsMkSmsGames(IsMkSmsGamesFromStorage === 'true')
      }
    }
  }, [])

  return { isMkSmsGames, setIsMkSmsGames }
}
